export enum SerialModelValidationStatus {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  INVALID_SERIAL = 'INVALID_SERIAL',
  MODEL_NOT_FOUND = 'MODEL_NOT_FOUND',
  NOT_REGISTERED_IN_SAP = 'NOT_REGISTERED_IN_SAP',
  NOT_REGISTERED = 'NOT_REGISTERED',
}
